import React from "react";
import { Icon, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";


type Props = {
    websiteGuid: string;
    hasOutages: boolean;
};


export default function SiteOutageSummary({ hasOutages, websiteGuid }: Props) {
    const navigate = useNavigate();
    const handleViewReport = () => {
        navigate(`/site-outage?w_guid=${websiteGuid}`);
    };
    return (
        <div className="dashboard-summary-section">
            <div className="container">
                <div className="dashboard-summary-section-title">
                    <span>Site Outage</span>
                    <Tooltip className="summary-tooltip" title={hasOutages ? "We've detected downtimes for this website" : "There are no downtimes reported for this website"}>
                        <Icon type="question-circle" />
                    </Tooltip>
                </div>
                <div className="dashboard-summary-section-result">
                    {hasOutages ? <span className="outage-message"> Outage detected</span> : <span className="no-outage-message">No issues found</span>}
                </div>
            </div>
            <div
                className="view-report-btn"
                onClick={handleViewReport}
            >
                <span>Outage report</span>
                <Icon type="right" />
            </div>
        </div>
    );
}
